export default __webpack_public_path__ + "static/media/num-icon3.eb1a739c.svg";